import React from 'react';

import { alwaysTrue } from 'utils/data';

import DateTimeCell from '../components/DateTimeCell';
import ExpandToggleButton from '../components/ExpandToggleButton';
import TaskRowActionButton from '../components/TaskRowActionButton';
import { ConditionsTestIds } from '../Conditions.testIds';

import { TaskTableCellId, taskTableCellWidthMap } from './ConditionTasksTable.constants';

export const getTasksTableConfig = ({
  conditionId,
  canRemoveTasks,
  expandedTaskId,
  onToggleTaskExpand,
}) => ({
  [TaskTableCellId.EXPAND]: {
    label: '',
    width: taskTableCellWidthMap[TaskTableCellId.EXPAND],
    align: 'center',
    content: ({ _task }) => (
      <ExpandToggleButton
        ariaLabelNoun="task"
        getTestId={ConditionsTestIds.getTaskExpandButtonId}
        isExpanded={expandedTaskId === _task.taskId}
        rowId={_task.taskId}
        onToggle={onToggleTaskExpand}
      />
    ),
  },
  [TaskTableCellId.NAME]: {
    label: 'Task Name',
    width: taskTableCellWidthMap[TaskTableCellId.NAME],
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ [TaskTableCellId.NAME]: cellData }) => cellData,
  },
  [TaskTableCellId.LAST_MODIFIED]: {
    label: 'Last Modified Date',
    width: taskTableCellWidthMap[TaskTableCellId.LAST_MODIFIED],
    sort: true,
    content: ({ [TaskTableCellId.LAST_MODIFIED]: cellData }) => <DateTimeCell value={cellData} />,
  },
  [TaskTableCellId.STATUS]: {
    label: 'Status',
    width: taskTableCellWidthMap[TaskTableCellId.STATUS],
    sort: true,
    renderContentAsText: alwaysTrue,
    content: ({ [TaskTableCellId.STATUS]: cellData }) => cellData,
  },
  [TaskTableCellId.ACTIONS]: {
    label: 'Actions',
    width: taskTableCellWidthMap[TaskTableCellId.ACTIONS],
    align: 'center',
    content: ({ _task }) => (
      <TaskRowActionButton canRemove={canRemoveTasks} conditionId={conditionId} task={_task} />
    ),
  },
});
